export default {
  namespaced: true,
  bau_complement: {
    title: "Complemento BAU",
    cctv_tracking: "Seguimiento CCTV",
    form_templates: "Plantillas de formulario",
    form_type: "Tipo de formulario",
    property_visits: "Visitas Inmuebles",
    list_title: "Complementos BAU",
    new: "Nuevo Complemento BAU",
    reference_number: "Número de Referencia",
    select_form: "Selecciona formularios",
    select_form_place_holder: "Seleccione un formulario",
    selected_form: "Formulario seleccionado",
    answer_form: "Iniciar formulario",
    start_form: "Iniciar formulario",
    confirm_delete: "¿Estás seguro de eliminar este complemento BAU?",
    no_records: "No se encontraron complementos BAU",
    reassign: "Reasignar",
    confirm_cancel: "¿Estás seguro de que deseas cancelar este complemento BAU?",
    canceled: "Complemento BAU cancelado",
    edit_form_answers: "Editar respuestas del formulario",
    related_forms: "Formularios relacionados",
    property: "Inmueble",
    previous_visits: "Visitas anteriores",
    one_required_field_missing: "Falta 1 campo obligatorio",
    multiple_required_fields_missing: "Faltan campos obligatorios",
  },
};
